export enum NonFiscalDocumentTypeEnum {
    _None,
    NonFiscal,
    HeaderProgramming,
    ImageProgramming,
    ClockProgramming,
    ConfigurationReport,
    ConfigurationIOReport,
    ServiceReport,
    OnlineReport,
    ConfigurationEReceiptReport,
    GraphicReport,
    StartCashierWork,
    FinishCashierWork,
}